import { ChevronRight } from "lucide-react"
import { type Icon } from "@tabler/icons-react"

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/shared/ui/collapsible"
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "@/shared/ui/sidebar"

export function NavMain({
  items,
}: {
  items: {
    title: string
    url: string
    icon?: Icon
    isActive?: boolean
    onClick?: () => void
    disabled?: boolean
    badgeText?: string
    items?: {
      title: string
      url: string
      isActive?: boolean
      onClick?: () => void
    }[]
  }[]
}) {
  return (
    <SidebarGroup>
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.map((item) => {
            // Check if any child item is active
            const hasActiveChild = item.items?.some((subItem) => subItem.isActive) ?? false;
            
            return (
            item.items ? (
              <Collapsible
                key={item.title}
                asChild
                defaultOpen={item.isActive || item.items.some((subItem) => subItem.isActive)}
                className="group/collapsible"
              >
                <SidebarMenuItem>
                  <CollapsibleTrigger asChild>
                    <SidebarMenuButton
                      tooltip={item.title}
                      isActive={item.isActive || hasActiveChild}
                      disabled={item.disabled}
                    >
                      {item.icon && <item.icon />}
                      <span>{item.title}</span>
                      {item.badgeText && (
                        <span className="ml-auto rounded-full border border-amber-500/30 bg-amber-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-500">
                          {item.badgeText}
                        </span>
                      )}
                      <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                    </SidebarMenuButton>
                  </CollapsibleTrigger>
                  <CollapsibleContent>
                    <SidebarMenuSub>
                      {item.items?.map((subItem) => (
                        <SidebarMenuSubItem key={subItem.title}>
                          <SidebarMenuSubButton asChild isActive={subItem.isActive}>
                            <div className="font-semibold cursor-pointer" onClick={subItem.onClick}>
                              <span>{subItem.title}</span>
                            </div>
                          </SidebarMenuSubButton>
                        </SidebarMenuSubItem>
                      ))}
                    </SidebarMenuSub>
                  </CollapsibleContent>
                </SidebarMenuItem>
              </Collapsible>
            ) : (
              <SidebarMenuItem key={item.title}>
                <SidebarMenuButton 
                  tooltip={item.title}
                  isActive={item.isActive}
                  onClick={item.onClick}
                  disabled={item.disabled}
                >
                  {item.icon && <item.icon size={16} />}
                  <span>{item.title}</span>
                  {item.badgeText && (
                    <span className="ml-auto rounded-full border border-amber-500/30 bg-amber-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-amber-500">
                      {item.badgeText}
                    </span>
                  )}
                </SidebarMenuButton>
              </SidebarMenuItem>
            )
          );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}
